import {
  ChangeDetectorRef,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { FormStatus, FormStatusService } from './form-status.service';

/**
 * Return whether formStatus is one of the options.
 */
@Pipe({ name: 'formStatus', pure: false })
export class FormStatusPipe implements PipeTransform, OnDestroy {
  constructor(
    private readonly formStatusService: FormStatusService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {
    this.change.pipe(takeUntil(this.destroy)).subscribe();
  }

  private readonly destroy = new Subject();

  private readonly change = this.formStatusService.value.pipe(
    tap(value => {
      this.status = value;
      this.changeDetectorRef.markForCheck();
    }),
  );

  private status: FormStatus;

  ngOnDestroy() {
    this.destroy.next(undefined);
  }

  transform(statuses: FormStatus[]) {
    return statuses.includes(this.status);
  }
}
